import CommonOperationClass from '../../../commonOperationClass';

const four = new CommonOperationClass('4');

export default four;
